import {ReactNode, useEffect} from 'react'
import {useAppearance} from './EnvironmentProvider'

type Props = {
  children: ReactNode
}

export const Theme = ({children}: Props) => {
  const appearance = useAppearance()

  const themeColor = appearance?.themeColor || '#FF9400'

  useEffect(() => {
    document.body.style.setProperty('--theme-color', themeColor)
  }, [themeColor])

  return <>{children}</>
}
